import React, { useState, useEffect, useContext } from 'react';
import {withRouter} from "../../lib/react/withRouter";

import * as net from "../../lib/net";
import sso from "../../sso";

function web01() {

    var html =
        <h4>Huvud</h4>
    ;
    return html;
}

class Pos_Eko extends React.Component {
  constructor(props, context) {
    super(props);

    this.webStore = props.store;
    this.state = {};
    this.state.seldate = new Date();
    this.state.avd = "01";
    this.state.paa = [];
    this.state.aa = [];

      this.state.mna = [];
      this.state.mna.push({ mnid: "mn01", pos: "c1", text: "REDOVISNING", desc: "Rapporter och försälningsunderlag", link: "/pos/eko/red" });
      this.state.mna.push({ mnid: "mn02", pos: "c1", text: "RAPPORTER", desc: "Rapporter och försälningsunderlag", link: "/pos/eko/rps" });
      this.state.mna.push({ mnid: "mn03", pos: "c1", text: "KASSA", desc: "Kassarapporter och myndighetsrapporter", link: "/pos/eko/kassa" });
      this.state.mna.push({ mnid: "mn04", pos: "c1", text: "LISTOR", desc: "Listor, sortiment mm", link: "/pos/eko/list" });
      this.state.mna.push({ mnid: "mn05", pos: "c2", text: "KONTON", desc: "Kontobaserad sammanställning", link: "/pos/eko/konto" });
      this.state.mna.push({ mnid: "mn06", pos: "c2", text: "TRANSAKTIONER", desc: "Periodens inslag", link: "/pos/eko/trs" });
      this.state.mna.push({ mnid: "mn07", pos: "c2", text: "KVITTON", desc: "Kvitto underlag", link: "/pos/eko/kvitton" });
      this.state.mna.push({ mnid: "mn08", pos: "c2", text: "KORT", desc: "Kort sammanställning", link: "/pos/eko/cc" });
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
  }

    mnc(pos) {
        var mna = [];
        for(var row of this.state.mna) {
            if(row.pos == pos) mna.push( row );
        }
        return mna;
    }
  fknGo(url) {
    //alert(row.href);
    var row = {};
    row.url = url;
    sso.seo.sfkn = row;
    this.props.navigate(url);
  }

  render() {
    return (
    <div className="web-app">
        <div className="web-pg py-4 flex">
            <h3>Ekonomi</h3>
            <p>Ekonomi funktioner</p>

            <div className="divider_green"></div>

            <div className="web-row">
                <div className="flex-col flex">
                    { this.mnc("c1").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="flex-col flex">
                    { this.mnc("c2").map((row, key) =>
                        <div key={key} className="web-bx" onClick={() => this.fknGo(row.link) }>
                            <div>{ row.text }</div>
                            <div className="flex-row">
                                <div className="flex">{ row.desc }</div>
                                <div className="web-link">Välj</div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    </div>
  );
    }
}
export default withRouter(Pos_Eko);
